import sendRequest from "@ecom/ui/utils/sendRequestV2"

import type { OfficeData, OfficeDataWithMoreInfo } from "../types"
import { HALVA_API_BASE_URL } from "../../../helpers/api"

export default function fetchOffices({
  kladrID,
  latitude,
  longitude,
  noFiltrationOffices,
}: {
  kladrID?: string
  longitude?: number
  latitude?: number
  noFiltrationOffices?: boolean
}): Promise<OfficeData[]> {
  const params: {
    countOffices: number
    clientType: string
    addressClassifier?: string
    longitude?: number
    latitude?: number
  } = {
    countOffices: 100,
    clientType: "INDIVIDUAL",
  }

  if (kladrID) {
    params.addressClassifier = kladrID
  } else if (latitude && longitude) {
    params.longitude = longitude
    params.latitude = latitude
  } else {
    return Promise.resolve([])
  }

  if (noFiltrationOffices) {
    return sendRequest(`${HALVA_API_BASE_URL}/v1/cache/pickup-points/nearby`, params).then(
      (points: OfficeDataWithMoreInfo[]) => points
    )
  }

  return sendRequest(`${HALVA_API_BASE_URL}/v1/cache/pickup-points/nearby`, params).then(
    (points: OfficeDataWithMoreInfo[]) =>
      points.filter(
        (item) => item.currencies?.personCash && !item.name.toLowerCase().includes("банкомат")
      )
  )
}
